import React from "react";
import { Box, Card, Skeleton, useTheme } from "@mui/material";

/**
 * Loading skeleton for app cards
 */
export function AppCardSkeleton() {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  return (
    <Card
      sx={{
        borderRadius: "16px",
        background: isDarkMode
          ? "linear-gradient(145deg, #1e293b 0%, #0f172a 100%)"
          : "#ffffff",
        border: `1px solid ${isDarkMode ? "#334155" : "#e2e8f0"}`,
        overflow: "hidden",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          p: 2,
          pb: 1.5,
          display: "flex",
          alignItems: "flex-start",
          gap: 1.5,
        }}
      >
        <Skeleton
          variant="circular"
          width={32}
          height={32}
          sx={{ bgcolor: isDarkMode ? "#334155" : "#e2e8f0" }}
        />
        <Box sx={{ flex: 1 }}>
          <Skeleton
            variant="text"
            width="70%"
            height={24}
            sx={{ bgcolor: isDarkMode ? "#334155" : "#e2e8f0" }}
          />
          <Skeleton
            variant="text"
            width="50%"
            height={16}
            sx={{ bgcolor: isDarkMode ? "#334155" : "#e2e8f0" }}
          />
        </Box>
      </Box>

      {/* Status Sections */}
      <Box
        sx={{
          px: 2,
          pb: 2,
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 2,
        }}
      >
        {/* Build Section */}
        <Box>
          <Skeleton
            variant="text"
            width={40}
            height={14}
            sx={{ bgcolor: isDarkMode ? "#334155" : "#e2e8f0", mb: 0.5 }}
          />
          <Skeleton
            variant="rounded"
            width={60}
            height={20}
            sx={{ bgcolor: isDarkMode ? "#334155" : "#e2e8f0", mb: 0.5 }}
          />
          <Skeleton
            variant="text"
            width={80}
            height={14}
            sx={{ bgcolor: isDarkMode ? "#334155" : "#e2e8f0" }}
          />
        </Box>

        {/* Runtime Section */}
        <Box>
          <Skeleton
            variant="text"
            width={50}
            height={14}
            sx={{ bgcolor: isDarkMode ? "#334155" : "#e2e8f0", mb: 0.5 }}
          />
          <Skeleton
            variant="rounded"
            width={70}
            height={20}
            sx={{ bgcolor: isDarkMode ? "#334155" : "#e2e8f0", mb: 0.5 }}
          />
          <Skeleton
            variant="text"
            width={100}
            height={14}
            sx={{ bgcolor: isDarkMode ? "#334155" : "#e2e8f0" }}
          />
        </Box>
      </Box>

      {/* Footer */}
      <Box
        sx={{
          px: 2,
          py: 1.5,
          background: isDarkMode ? "rgba(0,0,0,0.2)" : "#f8fafc",
          borderTop: `1px solid ${isDarkMode ? "#334155" : "#e2e8f0"}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Skeleton
          variant="text"
          width={120}
          height={16}
          sx={{ bgcolor: isDarkMode ? "#334155" : "#e2e8f0" }}
        />
        <Box sx={{ display: "flex", gap: 0.5 }}>
          <Skeleton
            variant="circular"
            width={24}
            height={24}
            sx={{ bgcolor: isDarkMode ? "#334155" : "#e2e8f0" }}
          />
          <Skeleton
            variant="circular"
            width={24}
            height={24}
            sx={{ bgcolor: isDarkMode ? "#334155" : "#e2e8f0" }}
          />
        </Box>
      </Box>
    </Card>
  );
}

export default AppCardSkeleton;
